import { defaultMaxPagination } from '@core/constants/reference-page-constant';
import { ChangePerformerFilter, OrderFilterDto } from '@core/interfaces/change-perform.interface';
import { GetListParams } from '@core/interfaces/get-list.interface';
import { RouteSheetsFilter } from '@core/interfaces/route-sheets.interface';

export class SetChangePerformerFilter {
  public static readonly type = '[SetUserRoles] Set User Roles';

  constructor(public params: ChangePerformerFilter) {}
}

export class ResetChangePerformerFilter {
  static readonly type = '[ChangePerformer] Reset Filter';
}

export class GetListRouteSheetsWithoutRouteAndOrder {
  static readonly type = '[GetListRouteSheetsWithoutRouteAndOrder] Get List Route Sheets Without Route And Order';

  constructor(public params: GetListParams<RouteSheetsFilter>) {}
}

export class ChangePerformerSetZoneId {
  static readonly type = '[ChangePerformer] Set Zone Id';

  constructor(public zoneId: number | null) {}
}

export class ChangePerformerSetCity {
  static readonly type = '[ChangePerformer] Set City';

  constructor(public cityId: number | null) {}
}

export class GetListOrdersChengePedrformer {
  static readonly type = '[ChangePerformer] Get List Orders';

  constructor(
    public params: OrderFilterDto,
    public pagination: { limit: number; offset: number } = defaultMaxPagination,
  ) {}
}
